<template>
    <div class="container">
        <div v-if="paymentMethod">
            {{ paymentMethod.website_description }}
        </div>
        <div v-if="!this.isCheckout">
            {{ trans.get('account.bank_payment_log_into') }}
            <div class="row ml-2 pb-3 pt-3">
                <div class="col-4">
                    {{ trans.get('account.bank_payment_iban') }}:
                </div>
                <div class="col-4">
                    <strong>{{ bank ? bank.iban : '' }}</strong>
                </div>
            </div>
            <div class="row ml-2 pb-3 pt-3">
                <div class="col-4">
                    {{ trans.get('account.bank_payment_swift') }}:
                </div>
                <div class="col-8">
                    <strong>{{ bank ? bank.swift_code : '' }}</strong>
                </div>
            </div>
            <div class="row ml-2 pb-3 pt-3">
                <div class="col-4">
                    {{ trans.get('account.amount') }}:
                </div>
                <div class="col-4">
                    <strong>{{ total | priceFormat() | withCurrency(currency) }}</strong>
                </div>
            </div>
            <div class="row ml-2 pb-3 pt-3">
                <div class="col-4">
                    {{ trans.get('account.bank_payment_reference') }}:
                </div>
                <div class="col-4">
                    <strong v-if="reference">{{ reference }}</strong>
                    <button v-else @click="createPaymentIntent" class="btn btn-red btn-sm">
                        {{ trans.get('account.bank_payment_generate_reference') }}
                    </button>
                </div>
            </div>
            <div v-if="paymentIsPendingApprove">
              <b-alert show variant="success">
                <strong>{{ trans.get('account.important') }}:</strong>
                {{ trans.get('account.payment_pending_approve') }}
              </b-alert>
            </div>
            <div v-else-if="paymentIsSuccess">
              <b-alert show variant="success">
                <strong>{{ trans.get('account.important') }}:</strong>
                {{ trans.get('account.payment_success') }}
              </b-alert>
            </div>
            <div v-else-if="paymentFailed">
              <b-alert show variant="danger">
                <strong>{{ trans.get('account.important') }}:</strong>
                {{ trans.get('account.payment_failed') }}
                <br>
                <br>
                <strong>{{ trans.get('account.reason') }}:</strong>
                {{ message }}
              </b-alert>
            </div>
            <div v-else-if="reference">
              <b-alert show variant="danger">
                <strong>{{ trans.get('account.important') }}:</strong>
                {{ trans.get('account.bank_payment_reference_usage_1_text') }}
              </b-alert>
              <b-alert show variant="info">
                <strong>{{ trans.get('account.reminder') }}:</strong>
                {{ trans.get('account.bank_payment_reference_usage_2_text') }}
              </b-alert>
            </div>
            <div v-else>
              <b-alert show variant="info">
                <strong>{{ trans.get('account.important') }}:</strong>
                {{ trans.get('account.bank_payment_to_process_generate_ref') }}
              </b-alert>
            </div>
        </div>
    </div>
</template>

<script>

import {mapFields} from "vuex-map-fields";
import {mapGetters} from "vuex";

export default {
  name: 'bank-transfer',
  props: {
    paymentMethod: Object,
  },
  data() {
    return {
      hasBody: true,
    }
  },
  methods: {
    createPaymentIntent() {
      let self = this;
      self.payment.payment_method = self.selectedPaymentMethod
      self.payment.invoices = this.pluck(self.invoices, 'invoice_number')
      self.payment.currency = self.currency.id
      self.payment.reference = self.reference
      axios.post(window.payment_intent_url, this.payment).then(function (response) {
        if (response.data) {
          self.reference = response.data.payment.reference;
          self.message = response.data.payment.message;
          self.paymentStatus = response.data.payment.status;
          self.loading = false;
          self.paymentMethods = self.paymentMethods.filter(function (paymentMethod, index, arr) {
            return paymentMethod.key === self.selectedPaymentMethod
          })
          window.history.pushState(null, null, window.linked_invoices_url + '/' + response.data.payment.reference);
        }
      }).catch(function (error) {
        console.warn(error);
        self.errors = error.response.data.errors;
      })
    },
    pluck(objs, name) {
      var sol = [];
      for (var i in objs) {
        if (objs[i].hasOwnProperty(name)) {
          sol.push(objs[i][name]);
        }
      }
      return sol;
    },
    createOrder() {
      let self = this;
      this.order.payment_method = this.selectedPaymentMethod;
      this.order.is_checkout = this.isCheckout;
      axios.post(window.create_order, this.order).then(function (response) {
        self.invoices = [];
        self.invoices.push(response.data.invoice.invoice_number);
        self.client_secret = '';
        if (response.data.paymentData.order) {
          self.$emit('success-booking');
        }
      }).catch(function (error) {
        self.errorsMessagesFromApi = error.response.data.errors;
        self.loading = false;
      })
    },
    ...mapGetters([
      'isSingleInvoice'
    ]),
  },
  computed: {
    ...mapFields([
      'invoices',
      'errors',
      'errorsMessagesFromApi',
      'isCheckout',
      'paymentMethods',
      'currency',
      'selectedPaymentMethod',
      'order.order_id',
      'order',
      'total',
      'payment',
      'loading',
      'reference',
      'payment.message',
      'paymentStatus',
      'bank',
    ]),
    isValid() {
      return this.reference !== '';
    },
    paymentIsPendingApprove() {
      return this.paymentStatus === PAYMENT_PENDING_APPROVAL
    },
    paymentIsSuccess() {
      return this.paymentStatus === PAYMENT_SUCCESS
    },
    paymentFailed() {
      return this.paymentStatus === PAYMENT_FAILED
    },
  },
  mounted() {
    if (!this.isCheckout && this.isSingleInvoice()) {
      this.reference = this.invoices[0].invoice_number;
    }
  }
};
</script>

<style scoped>

</style>
